<div class="progress-outer">
  <div class="progress-inner" [style.width]="progressWidth() + '%'">{{progress}}%</div>
</div>
